<template>
  <div class="app-container center">
    <!-- <component :is="currentRole" /> -->
    <img
      style="position: absolute;top: 50%; transform: translateY(-50%);"
      :src="logo"
      alt=""
    >
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'
// import adminDashboard from './admin'

export default {
  name: 'Dashboard',
  components: { /* adminDashboard*/ },
  data() {
    return {
      logo: require('@/assets/larke/company.0ede7515.png')
      // currentRole: 'adminDashboard'
    }
  },
  computed: {
    // ...mapGetters([
    //   'roles'
    // ])
  },
  created() {
    console.log('首页this.$route.query.token', this.$route.query)
  }
}
</script>
<style scoped>
.center {
  height: 75%;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 768px) {
  img{
    width:90vw !important;
  }
}
</style>
